import axios from "axios";

class LocationService {
    getUserLocation() {
        return new Promise((resolve, reject) => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.getPostionData(position.coords.latitude, position.coords.longitude).then(data => resolve(data)).catch(err => reject(err));
                }, (error_message) => {
                    console.error('An error has occured while retrieving location', error_message);
                    reject(false);
                    //this.ipApiLookUp().then(data => resolve(data)).catch(err => reject(err));
                })
            } else {
                console.error('Location is not enabled');
                reject(false);
                //this.ipApiLookUp().then(data => resolve(data)).catch(err => reject(err));
            }
        });

    }
    getPostionData(lat, lon) {
        return new Promise((resolve, reject) => {
            axios.get(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`)
                .then(({ data }) => {
                    return resolve({
                        countryCode: data.address ? data.address.country_code.toUpperCase() : null,
                        latitude: lat,
                        longitude: lon,
                        city: data.address ? data.address.city : null
                    });
                }).catch(err => {
                    console.error(err);
                    return reject(err);
                })
        })

    }
    ipApiLookUp() {
        return new Promise((resolve, reject) => {
            axios.get('https://ipapi.co/json').then(({ data }) => {
                resolve({
                    countryCode: data.country_code,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    city: data.city,
                    region: data.region
                })
            }).catch(err => {
                console.error(err);
                reject(err);
            })
        })
    }
}

export default new LocationService();
